import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import FullPageSpinner from 'components/common/full-page-spinner';
import { getIpfs } from 'services/productionOverviewService';
import { COST_SECTIONS, getWeekRange } from '../cost/costHelpers';
import IpfCategoryTable from '../cost/IpfCategoryTable';
import IpfBreakdownChart from '../cost/IpfBreakdownChart';
import '../cost/CostTab.css';

export default function CostTab({ date }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCode, setSelectedCode] = useState(null);

  const { startDate, endDate, days } = useMemo(() => getWeekRange(date), [date]);

  const tableRecords = useMemo(() => (selectedCode ? records.filter(r => r.pCode === selectedCode) : records), [records, selectedCode]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setSelectedCode(null);
    getIpfs(startDate, endDate)
      .then(result => {
        if (cancelled) return;
        const data = result?.data?.data || result?.data || [];
        setRecords(Array.isArray(data) ? data : []);
      })
      .catch(err => {
        if (!cancelled) console.error('Error fetching IPF cost summary', err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [date, startDate, endDate]);

  return (
    <div style={{ position: 'relative' }}>
      <FullPageSpinner show={loading} quantity={3} />

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h3 style={{ margin: 0 }}>Cost — IPF Summary</h3>
        <span style={{ fontSize: 13, color: '#6c757d' }}>Week commencing {days[0]}</span>
      </div>

      {!loading && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {COST_SECTIONS.map(section => (
              <div key={section.category} style={{ flex: 1, minWidth: 260 }}>
                <IpfCategoryTable title={section.title} records={tableRecords} days={days} category={section.category} />
              </div>
            ))}
          </div>

          <IpfBreakdownChart records={records} selectedCode={selectedCode} onSelectCode={setSelectedCode} />
        </div>
      )}
    </div>
  );
}

CostTab.propTypes = {
  date: PropTypes.string.isRequired
};
